import { Box, Typography } from "@mui/material";

const LoadingState = () => (
  <Box display="flex" justifyContent="center" alignItems="center" height="200px">
    <Typography>Loading customers...</Typography>
  </Box>
);

export default LoadingState;
